// This file configures the initialization of Sentry on the client (Next loads it before the app, in every browser).
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"46cecedd28f8747c5b1532026a7ef82233216780"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.4.0";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/identity-verification\"},{\"path\":\"/sign-agreement\"},{\"path\":\"/login\"},{\"path\":\"/no-access\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/superuser/kyc\"},{\"path\":\"/superuser/offboarding\"},{\"path\":\"/superuser/payouts\"}],\"isrRoutes\":[]}";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  enabled: process.env.NODE_ENV !== 'development',
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV,
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})

// Instruments App Router navigations (Next 15.3+ calls this on every client-side route change)
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
